import api, { ResponseCallback } from '../services/api.service'

export interface AdminSignInRequest {
  username?: string
  password?: string
}

interface AdminSignInResponse {
  token: string
}

const routes = {
  signIn: '/admin/signIn'
}

export default {
  signIn (
    payload: AdminSignInRequest,
    callback: ResponseCallback<AdminSignInResponse>
  ) {
    api.post(routes.signIn, payload, callback)
  }
}
